import { ReactComponent as BoxIllustration } from "assets/illustrations/empty-box.svg";

import { Container } from "./styles";

type Props = {
  title: string;
};

export function EmptyState({ title }: Props) {
  return (
    <Container>
      <BoxIllustration />

      <span>{title}</span>
    </Container>
  );
}
